const TextToSpeech = (data, volume) => {
  const utterance = new SpeechSynthesisUtterance(data);
  const voices = window.speechSynthesis.getVoices();

  // Find a male voice if available
  const maleVoice = voices.find((voice) => voice.gender === "male");

  if (maleVoice) {
    utterance.voice = maleVoice;
  } else {
    // Fallback to the default voice if no male voice is found
    console.warn("No male voice found. Using default voice.");
    utterance.voice = voices[1];
  }

  // Adjust speech properties
  utterance.rate = 1.2; // Increase the rate for a more cheerful tone
  utterance.pitch = 1.5; // Increase the pitch for a higher and more lively voice
  // Set the volume (range: 0 to 1)
  utterance.volume = volume ? 0 : 1;

  window.speechSynthesis.speak(utterance);
};

export default TextToSpeech;
